export default {
  title: {
    list: "運営会社参照許可",
    edit: "運営会社参照許可編集"
  },
  errors: {
    getAccount: "アカウント一覧の取得に失敗しました。",
    getOperationOffice: "運営会社一覧の取得に失敗しました。",
  },
  validate: {
    required: "入力してください。",
    max5TextRequired: "5文字以内で入力してください。",
    max20BytesTextRequired: "半角20文字／全角10文字以内で入力してください。",
    max30BytesTextRequired: "半角30文字／全角15文字以内で入力してください。",
    max40BytesTextRequired: "半角40文字／全角20文字以内で入力してください。",
    QuantityRefuelingNumber: "0.00〜999.99の間の数値で入力してください。",
    QuantityRefuelingDecimal: "小数点第二位までで入力してください。",
    QuantityLoadingAndUnloadingNumber: "0.00〜99999.9999の間の数値で入力してください。",
    QuantityLoadingAndUnloadingDecimal: "小数点第四位までで入力してください。"
  }
}
